import { render } from "./edit.svg?vue&type=template&id=3cf74b2b?inline"
const script = {}
script.render = render

export default script